import React from 'react';

import style from './contact.module.scss';

import { Banner } from './banner';
import { Content } from './content';

export const Contact = () => {
    return (
        <div className={style.contact}>
            <Banner></Banner>
            <Content></Content>
        </div>
    );
};
